import {Inject, Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {API_URL} from "../../../../lib-base/src/lib/shared";
import {Observable} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class InstructivosService {

  private baseUrl: string ;

  constructor(@Inject(API_URL) public apiUrl: string, private http: HttpClient) {
    this.baseUrl = `${this.apiUrl}/api/instructivos`;
  }

  getDocumentoByID(id: number): Observable<Blob> {
    return this.http.get(`${this.baseUrl}/public/${id}`,
      {responseType: 'blob'});
  }
}
